import { createStyles } from 'antd-style';
import { colors } from '../../styles/colors';

const useStyles = createStyles(() => {
  return {
    'title': {
      'color': `${colors['--triad-blue-0']} !important`,
      '@media (max-width: 768px)': {
        textAlign: 'center',
      },
    },
    'price-card': {
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px',
      height: '55px',
      padding: '4px 8px',
    },
    'price-card-selected': {
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px',
      height: '55px',
      padding: '4px 8px',
      border: `2px solid ${colors['--triad-blue-0']}`,
      boxShadow: `5px 5px 5px ${colors['--triad-blue-0']}`,
    },
    '.ant-card-actions': {
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px',
      height: '55px',
    },
    '.ant-list-sm': {
      padding: '4px 8px',
    },
    '.ant-list-item': {
      padding: '4px 8px',
    },
    'card-title': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    'support-dropdown-ru': {
      fontSize: '11px',
    },
    '.ant-select-item': {
      fontSize: '11px',
    },
    '.ant-select-item-option-content': {
      fontSize: '11px',
    },
    'selected-plan-checkbox': {
      marginRight: '10px',
      fontSize: '30px',
      color: colors['--triad-blue-0'],
    },
    'unselected-plan-checkbox': {
      marginRight: '10px',
      fontSize: '30px',
      color: colors['--triad-blue-1'],
    },
    'clients-number': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    'clients-number-input': {
      marginLeft: 'auto',
    },
    'action-row': {
      color: colors['--triad-blue-0'],
      fontSize: '16px',
      fontWeight: 600,
    },
    'legal-links': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '20px',
    },
  };
});

export default useStyles;
